
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { class_type, record_type, bool_type, option_type, union_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { StocktakingEmailLinkCountingDto_$reflection } from "../../Shared/Stocktaking.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { CountingMsg_$reflection, CountingState_$reflection } from "../StocktakingList/Types.js";

export class LinkProblem extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Invalid", "Rejected"];
    }
}

export function LinkProblem_$reflection() {
    return union_type("Stocktaking.CountByLink.Types.LinkProblem", [], LinkProblem, () => [[], [["messageKey", string_type]]]);
}

export class State extends Record {
    constructor(LinkId, Data, Problem, Counting, FormState, IsCompleteDialogOpen, IsCompleted) {
        super();
        this.LinkId = LinkId;
        this.Data = Data;
        this.Problem = Problem;
        this.Counting = Counting;
        this.FormState = FormState;
        this.IsCompleteDialogOpen = IsCompleteDialogOpen;
        this.IsCompleted = IsCompleted;
    }
}

export function State_$reflection() {
    return record_type("Stocktaking.CountByLink.Types.State", [], State, () => [["LinkId", string_type], ["Data", RequestedValue$1_$reflection(StocktakingEmailLinkCountingDto_$reflection())], ["Problem", option_type(LinkProblem_$reflection())], ["Counting", CountingState_$reflection()], ["FormState", FormState_$reflection()], ["IsCompleteDialogOpen", bool_type], ["IsCompleted", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FetchData", "DataFetched", "FetchFailed", "Counting", "SetCompleteDialogOpen", "CompleteList", "ListCompleted", "CompleteFailed"];
    }
}

export function Msg_$reflection() {
    return union_type("Stocktaking.CountByLink.Types.Msg", [], Msg, () => [[], [["Item", StocktakingEmailLinkCountingDto_$reflection()]], [["Item", class_type("System.Exception")]], [["Item", CountingMsg_$reflection()]], [["Item", bool_type]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

